import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";

function StatCard({ title, value, icon, growth }) {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        width: isMobile ? "75vw" : isTablet ? "85vw" : "275px",
        minWidth: isTablet ? "100%" : "unset",
        background:
          "linear-gradient(135deg, #00B894 0%,rgb(44, 206, 130) 100%)",
        color: "white",
        borderRadius: "16px",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 12px 40px rgba(0, 175, 185, 0.4)",
          alignItems:"center"
        },
      }}
    >
      <CardContent
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          p: isTablet ? 2 : 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Box>
            <Typography
              variant="body2"
              sx={{
                opacity: 0.9,
                fontSize: isTablet ? "0.75rem" : "0.85rem",
                fontWeight: 500,
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                mt: 1,
                fontSize: isTablet ? "1.5rem" : "2rem",
              }}
            >
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              borderRadius: "12px",
              p: isTablet ? 1 : 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {React.cloneElement(icon, {
              sx: {
                fontSize: isTablet ? "1.5rem" : "2rem",
              },
            })}
          </Box>
        </Box>
        {growth && (
          <Typography
            variant="body2"
            sx={{
              opacity: 0.9,
              fontSize: isTablet ? "0.7rem" : "0.8rem",
              mt: 1,
            }}
          >
            {growth}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}

export default StatCard;
